export default __webpack_public_path__ + "static/media/howto.80f32e23.svg";